var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable react/no-array-index-key */
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import formatCharToSuperscript from '../../../../../helpers/formatCharToSuperscript';
import RewardsClients, { OwnRewardsClients } from '../../../../../const/clients';
import { useRewardsPageContext } from '../../../context/rewardsPageContext';
import IMAGE_ASSET_PATHS from '../../../../../const/assets';
import { useRewardsConfigContext } from '../../../../../context/rewardsConfig';
import useRewards from '../../../../../hooks/useRewards';
import { CreditCardImage, EarnPointsText, ImgContainer, ShopMoreButton, ShopMoreContainer, ShopMoreHeader, SuperscriptContainer, WithYour } from './subcomponents';
var ShopMore = function (_a) {
    var _b, _c, _d, _e, _f;
    var className = _a.className;
    var _g = useState(false), isVertical = _g[0], setIsVertical = _g[1];
    var imgRef = useRef(null);
    var t = useTranslation().t;
    var config = useRewardsConfigContext().config;
    var _h = useRewards(), accountSummary = _h.accountSummary, cardType = _h.cardType, clientId = _h.clientId, rewardsExperience = _h.rewardsExperience;
    var isActiveRewardsTab = useRewardsPageContext().state.isActiveRewardsTab;
    var assets = config.hosts.assets;
    var defaultCardArt = "".concat(assets, "assets/cardArt/syf_generic_card.svg");
    var actionButton = (_c = (_b = rewardsExperience[clientId]) === null || _b === void 0 ? void 0 : _b[cardType]) === null || _c === void 0 ? void 0 : _c.actionButton;
    var isOnePayWalmartPLCC = clientId === RewardsClients.onepaywalmart &&
        ((_d = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product) === null || _d === void 0 ? void 0 : _d.type) === 'PRIVATE_LABEL';
    var onClick = function () {
        if (actionButton === null || actionButton === void 0 ? void 0 : actionButton.link) {
            window.open(actionButton.link, '_blank');
        }
    };
    var handleImageError = function (e, fallbackImage) {
        var event = e.target;
        if (event.src !== fallbackImage) {
            event.onerror = null;
            event.src = fallbackImage;
        }
    };
    /**
     * isActiveRewardsTab is true when current tab is rewards, otherwise false.
     */
    var earnPointsDesc = t("shopMore.earnPoints.default");
    if (isActiveRewardsTab) {
        earnPointsDesc = t("shopMore.earnPoints.".concat([clientId]));
    }
    var handleLoad = function () {
        if (!imgRef.current)
            return;
        var _a = imgRef.current, naturalHeight = _a.naturalHeight, naturalWidth = _a.naturalWidth;
        setIsVertical(naturalHeight > naturalWidth);
    };
    return (_jsxs(ShopMoreContainer, __assign({ "data-cy": "shop-more-container" }, { children: [_jsxs(ImgContainer, { children: [_jsx("img", { src: "".concat(assets.origin, "/").concat(IMAGE_ASSET_PATHS.SPARKS_ANIMATION), alt: "spark animation" }), _jsx(CreditCardImage, { src: (_f = (_e = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.card) === null || _e === void 0 ? void 0 : _e.cardArtURL) !== null && _f !== void 0 ? _f : defaultCardArt, onError: function (e) { return handleImageError(e, defaultCardArt); }, alt: "credit card image", ref: imgRef, onLoad: handleLoad, vertical: isVertical })] }), isOnePayWalmartPLCC ? (_jsxs(ShopMoreHeader, __assign({ className: className, weight: "bold", "data-cy": "shop-more-title" }, { children: [t('shopMore.onepaywalmartPlccText'), _jsx(SuperscriptContainer, { children: "*" })] }))) : (_jsxs(_Fragment, { children: [_jsx(ShopMoreHeader, __assign({ weight: "bold", "data-cy": "shop-more-earn-more" }, { children: t('shopMore.earnMoreRewards') })), (accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product.displayName) && (_jsxs(WithYour, __assign({ className: className, "data-cy": "shop-more-with-your" }, { children: ["".concat(t('shopMore.withYour'), " "), formatCharToSuperscript(accountSummary.product.displayName, /(†|®)/, ['†', '®']), clientId in OwnRewardsClients && (_jsx(SuperscriptContainer, { children: "*" }))] }))), rewardsExperience && (_jsx(EarnPointsText, __assign({ "data-cy": "shop-more-earn-points" }, { children: earnPointsDesc })))] })), rewardsExperience && (actionButton === null || actionButton === void 0 ? void 0 : actionButton.text) && (_jsx(ShopMoreButton, __assign({ buttonType: "primary", onClick: onClick, "data-cy": "aside-panel-button", "data-type": "rewards", "data-reason": "Go To Rewards", "data-object": "button", "data-analytics": "clicktrackingevent" }, { children: t(actionButton === null || actionButton === void 0 ? void 0 : actionButton.text) })))] })));
};
export default ShopMore;
